import CacheStore from './cache-store'

export default new CacheStore()
